window.o_global = window.o_global || {};

/**
 * Tooltip Class
 *
 * @constructor
 *
 * @param {Object} trigger      DOM-Element with js-trigger-class.
 */
window.o_global.pali.Tooltip = function (trigger) {
  this.trigger = trigger; // DOM-Element that triggers tooltip
  this.tooltip = undefined; // DOM-Element of tooltip

  this.tooltipX = 0; // If position is set with (20;30), then this.tooltipX = 20;
  this.tooltipY = 0; // If position is set with (20;30), then this.tooltipY = 30;
  this.baseClass = "p_tooltip"; // Style class for tooltip-div-container
  this.mouseOffset = 0; // MouseOffset only needed in case of position = "mouse" ( --> mousemove)

  this.throttleTime = 16.6; // ThrottleTime determines speed to move the mouse --> time moveTooltip is called
  this.isActive = true; // If the tooltip should not be shown anymore --> this.deactivateTooltip()
  this.tooltipIsVisible = false; // Value = true: Tooltip is shown, value = false: Tooltip is hidden
  this.avoidCloseTooltip = false; // IE Bugfix for hybrid devices when after pointerdown-event mouseleave-event is fired
  this.type = ""; // Visual Type like "hint,success,warning,error"

  this.orientation = 1; // Default orientation of tooltip --> this.orientationVariations

  // Different possibilities to style the tooltip and its arrow position. default is horizontal (= 1)
  this.orientationVariations = {
    1: "p_tooltipHorizontal",
    2: "p_tooltipHorizontal p_tooltipHorizontalTop",
    3: "p_tooltipHorizontal p_tooltipHorizontalRight",
    4: "p_tooltipHorizontal p_tooltipHorizontalTop p_tooltipHorizontalRight",
  };

  /*
   * DataSettings-keys must also be a class-attribute:
   *      these are parsed automatically into the class attribute, that is named like the key
   */
  this.dataSettings = {
    text: "data-tooltip", // Required, if reference: optional: tooltip text
    reference: "data-tooltip-ref", // Required, if text: optional: tooltip reference: #id of DOM to load inside tooltip
    referenceToClone: "data-tooltip-ref-clone", // Optional, only combined with tooltip reference; clones node and let reference node in dom
    additionalStyleClasses: "data-tooltip-class", // Optional: additional tooltip style-classes
    additionalContainerClasses: "data-tooltip-container-class", // Optional: additional tooltip container-classes
    position: "data-tooltip-pos", // Optional: position of tooltip, values: mouse, (x,y)
    showForTouch: "data-tooltip-touch", // Optional: default = true; if value = false, for touch is not implemented
    hasCloseButton: "data-tooltip-close", // Optional: default = true; if value = false, close-button is not shown
    triggerClick: "data-tooltip-trigger-click", // Optional: default = false; if value = true, the popup will only show on click
    type: "data-tooltip-type", // Optional: type of tooltip, one of "hint,success,warning,error"
    trackingObject: "data-trackingobject", // Optional: Send tracking object when opened.
  };

  // Class-attributes of dataSettings above, with default values
  this.text = "";
  this.additionalStyleClasses = "";
  this.additionalContainerClasses = "";
  this.reference = undefined;
  this.referenceToClone = false;
  this.position = "";
  this.showForTouch = true;
  this.triggerClick = false;
  this.hasCloseButton = true;
  this.trackingObject = undefined;

  this._init();
};

/**
 * Getter of showForTouch.
 * (In case of false: do not event.preventDefault() in window.o_global.pali.tooltipHandler._buildTooltip()).
 *
 * @return {Boolean} this.showForTouch
 */
window.o_global.pali.Tooltip.prototype.getShowForTouch = function () {
  return this.showForTouch;
};

/**
 * EventHandler to hide Tooltip.
 * to hide a tooltip it must be removed from DOM (document.body).
 * For touch-devices the global EventListener has to be removed to blur
 * the tooltip (in case of touch anywhere in the DOM) has to be removed.
 */
window.o_global.pali.Tooltip.prototype.hideTooltip = function () {
  if (this.tooltipIsVisible && !this.avoidCloseTooltip) {
    if (window.o_global.device.isTouchable || this.triggerClick) {
      if ("onpointerdown" in window && !("ontouchstart" in window)) {
        document.removeEventListener(
          "pointerdown",
          window.o_global.pali.tooltipHandler.blurTooltip
        );
      } else {
        document.body.removeEventListener(
          "touchstart",
          window.o_global.pali.tooltipHandler.blurTooltip
        );
      }
    }

    document.body.removeChild(this.tooltip);
    this.tooltipIsVisible = false;
  }
};

/**
 * EventHandler to move Tooltip, when position="mouse".
 * sets x,y-position for different browsers (considers page scrolling) to calculate correct Tooltip Position.
 *
 * @param {Object} e    Event
 */
window.o_global.pali.Tooltip.prototype.moveTooltip = function (e) {
  // See: https://github.com/jshint/jshint/issues/1425
  if (!e.pageX && typeof e.clientX === "unknown") {
    // IE <= 10 fix... e.* is sometimes forbidden if called in setTimeout
    return false;
  }

  const xPos = e.pageX || e.clientX + document.documentElement.scrollLeft;
  const yPos = e.pageY || e.clientY + document.documentElement.scrollTop;

  this.calculateTooltipPosition(xPos, yPos, true);
};

/**
 * EventHandler to show Tooltip.
 * Tooltip is shown if it is no touchable device OR if is touchable and touch is not explicit prohibited by setting
 * data-tooltip-touch="false". If Tooltip is called for the first time, it must be instantiated.
 * Each time a tooltip is shown, it must be placed in the DOM (document.body).
 */
window.o_global.pali.Tooltip.prototype.showTooltip = function () {
  if (this.isActive) {
    if (
      !window.o_global.device.isTouchable || // For all non-touch devices
      this.triggerClick || // For all non-touch-devices with data-tooltip-trigger-click="true"
      this.showForTouch || // For all touch devices without data-tooltip-touch="false"
      window.o_global.device.hybrid.isDetected
    ) {
      // For all mouse-events on hybrids, if data-tooltip-touch="false"
      window.o_global.pali.tooltipHandler.changeActiveTooltip(this);

      if (!this.tooltip) {
        this._createTooltip();
        document.body.appendChild(this.tooltip);
        this.calculateTooltipPosition();
      } else {
        document.body.appendChild(this.tooltip);
        this.calculateTooltipPosition(); // After scrolling, position of tooltip could have changed
      }

      this.tooltipIsVisible = true;

      if (window.o_global.device.isTouchable || this.triggerClick) {
        // Must be defined globally, because of a bug e.g. in iPhone 4 / iOS 7.1.2
        if ("onpointerdown" in window && !("ontouchstart" in window)) {
          // For IE on hybrid devices
          document.addEventListener("pointerdown", window.o_global.pali.tooltipHandler.blurTooltip);
        } else if ("ontouchstart" in window) {
          document.body.addEventListener(
            "touchstart",
            window.o_global.pali.tooltipHandler.blurTooltip
          );
        } else {
          document.body.addEventListener("click", window.o_global.pali.tooltipHandler.blurTooltip);
        }
      }

      if (this.trackingObject) {
        try {
          window.o_global.eventQBus.emit(
            "tracking.bct.submitEvent",
            JSON.parse(this.trackingObject)
          );
        } catch (e) {}
      }
    }
  }
};

/**
 * EventHandler for touch devices that toggles between show and hide tooltip.
 *
 * @param {Object} e    Event
 */
window.o_global.pali.Tooltip.prototype.toggleTooltip = function (e) {
  if (this.isActive) {
    window.o_util.event.stop(e);

    if (this.tooltipIsVisible) {
      this.avoidCloseTooltip = false;
      this.hideTooltip();
    } else {
      this.avoidCloseTooltip = true;
      this.showTooltip();
    }
  }
};

/**
 * Calculates position of Tooltip dynamically and defines due to this calculation its position and its orientation-style.
 * These values can change, e.g. if the window scrolls and the tooltip has no space to be shown over the trigger (as
 * default), then it is shown under the trigger. This has an impact on the position and the orientation.
 * Also data-attributes affect this behaviour, e.g. this.position = "mouse" or "20;30"
 * Finally the correct x,y position and the correct orientation-style are set.
 *
 * @param {Number} [left]         Optional: triggerPositionLeft, e.g. pageX
 * @param {Number} [top]          Optional: triggerPositionTop, e.g. pageY
 * @param {Boolean} [isMouse]     Optional: true if position = "mouse"
 */
window.o_global.pali.Tooltip.prototype.calculateTooltipPosition = function (left, top, isMouse) {
  const arrowBorderDistance = 19;
  let triggerTop;
  let triggerLeft;
  let box = {
    top: 0,
    left: 0,
  };
  const triggerWidth = isMouse ? 0 : this.trigger.offsetWidth;
  let triggerHeight = isMouse ? 0 : this.trigger.offsetHeight;
  const halfTriggerWidth = Math.floor(triggerWidth / 2);
  const tooltipWidth = this.tooltip.offsetWidth;
  const tooltipHeight = this.tooltip.offsetHeight;
  const scrollLeft = window.scrollX;
  const scrollTop = window.scrollY;
  let offset = this.mouseOffset || 12;
  let calculatedOrientation;
  let calculatedTop;
  let calculatedLeft;

  // Calculate trigger position relative to document
  if (typeof this.trigger.getBoundingClientRect !== "undefined") {
    box = this.trigger.getBoundingClientRect();
  }

  triggerTop =
    top ||
    box.top +
      (window.pageYOffset || document.documentElement.scrollTop) -
      (document.documentElement.clientTop || 0);
  triggerLeft =
    left ||
    box.left +
      (window.pageXOffset || document.documentElement.scrollLeft) -
      (document.documentElement.clientLeft || 0);

  calculatedOrientation = 1;
  calculatedLeft = triggerLeft + halfTriggerWidth - arrowBorderDistance;
  if (
    window.innerWidth + scrollLeft < calculatedLeft + tooltipWidth &&
    scrollLeft < triggerLeft + halfTriggerWidth - tooltipWidth + arrowBorderDistance
  ) {
    calculatedOrientation = 3;
    calculatedLeft = triggerLeft + halfTriggerWidth - tooltipWidth + arrowBorderDistance;
  }

  calculatedTop = triggerTop - tooltipHeight - offset;
  if (
    scrollTop > calculatedTop &&
    scrollTop + window.innerHeight > triggerTop + offset + tooltipHeight
  ) {
    if (calculatedOrientation === 3) {
      calculatedOrientation = 4;
    } else {
      calculatedOrientation = 2;

      // In case of horizontal-orientation-switch with determined x,y-position,
      // The vertical-tooltip-layer positioning must not be adjusted to the trigger
      if (this.tooltipY !== 0 || this.tooltipX !== 0) {
        triggerHeight = 0;
        offset = 0;
      }
    }

    calculatedTop = triggerTop + triggerHeight + offset;
  }

  this.tooltip.style.left = this._getPixel(calculatedLeft + this.tooltipX);
  this.tooltip.style.top = this._getPixel(calculatedTop + this.tooltipY);

  if (calculatedOrientation !== this.orientation) {
    this.removeTooltipStyleClass(this.tooltip, this.orientationVariations[this.orientation]);
    this.orientation = calculatedOrientation;
    this.addTooltipStyleClass(this.tooltip, this.orientationVariations[this.orientation]);
  }
};

/**
 * Adds a styleClass to a DOM-Element, e.g. this.tooltip or this.closeBtn.
 *
 * @param {Object} scope        DOM-Element to style.
 * @param {String} styleClass   Name of Style-Class or space separated list.
 */
window.o_global.pali.Tooltip.prototype.addTooltipStyleClass = function (scope, styleClass) {
  scope.classList.add.apply(scope.classList, styleClass.split(" "));
};

/**
 * Removes a styleClass of a DOM-Element, e.g. this.tooltip in case of new orientation.
 *
 * @param {Object} scope        DOM-Element to style.
 * @param {String} styleClass   Name of Style-Class or space separated list.
 */
window.o_global.pali.Tooltip.prototype.removeTooltipStyleClass = function (scope, styleClass) {
  scope.classList.remove.apply(scope.classList, styleClass.split(" "));
};

/**
 * Activates Tooltip and shows it. Only called from external.
 */
window.o_global.pali.Tooltip.prototype.activateTooltip = function () {
  const triggerClass = "js_hasPaliTooltip";

  this.isActive = true;
  this.removeTooltipStyleClass(this.trigger, triggerClass);
  this.addTooltipStyleClass(this.trigger, `${triggerClass}--done`);

  this.showTooltip();
};

/**
 * Defines, that Tooltip is deactived.
 */
window.o_global.pali.Tooltip.prototype.deactivateTooltip = function () {
  this.isActive = false;
  this.hideTooltip();
};

/**
 * Called from constructor. Handle data-parsing and initializes tooltip-events.
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._init = function () {
  this._parseDataAttributes();
  this._initTooltipEvents();
  this.trigger.tooltipInstance = this;
};

/**
 * Parses defined data-attributes in the trigger --> data-attributes are defined dataSettings-map.
 * The key of the dataSettings is the defined class-attribute, e.g. {text: "data-tooltip"} the data-tooltip-value of
 * the trigger will be parsed in the class-attribute this.text.
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._parseDataAttributes = function () {
  let parsedAttribute = null;
  let attribute;

  for (const key in this.dataSettings) {
    if (this.dataSettings.hasOwnProperty(key)) {
      attribute = this.trigger.getAttribute(this.dataSettings[key]);

      if (attribute) {
        parsedAttribute = null;

        /* Change strings to data-types */
        switch (attribute) {
          case "false":
            parsedAttribute = false;
            break;
          case "true":
            parsedAttribute = true;
            break;
          default:
            parsedAttribute = attribute;
        }
        this[key] = parsedAttribute;
      }
    }
  }
};

/**
 * Initialize tooltip Events in consideration of the device (touchable or not).
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._initTooltipEvents = function () {
  if (this.triggerClick) {
    this.trigger.addEventListener("click", window.o_util.core.bind(this, this.toggleTooltip));
  } else if (window.o_global.device.isTouchable) {
    if (this.showForTouch) {
      this._initTooltipTouchEvents();
    }

    if (window.o_global.device.hybrid.isDetected) {
      this._initTooltipMouseEvents();
    }
  } else {
    this._initTooltipMouseEvents();
  }
};

/**
 * Initializes touch events to show and hide tooltip.
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._initTooltipTouchEvents = function () {
  const that = this;

  if ("onpointerdown" in window && !("ontouchstart" in window)) {
    if (window.o_global.device.hybrid.isDetected) {
      this.trigger.addEventListener(
        "pointerdown",
        window.o_util.core.bind(this, function () {
          that.avoidCloseTooltip = !that.avoidCloseTooltip;
        })
      );
    } else {
      this.trigger.addEventListener(
        "pointerdown",
        window.o_util.core.bind(this, this.toggleTooltip)
      );
    }
  } else {
    this.trigger.addEventListener("touchstart", window.o_util.core.bind(this, this.toggleTooltip));
  }
};

/**
 * Initializes mouseevents to show and hide tooltip.
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._initTooltipMouseEvents = function () {
  this.trigger.addEventListener("mouseenter", window.o_util.core.bind(this, this.showTooltip));
  this.trigger.addEventListener("mouseleave", window.o_util.core.bind(this, this.hideTooltip));

  if (this.position === "mouse") {
    this.mouseOffset = 20;
    this.trigger.addEventListener(
      "mousemove",
      window.o_util.core.bind(this, this._throttle(this.moveTooltip, this.throttleTime))
    );
  }
};

/**
 * Creates tooltip-element and sets its text and styleClasses. In case of touch and initializes the close-button if
 * this.hasCloseButton = true ( --> default = true, can be set by data-tooltip-close = "false").
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._createTooltip = function () {
  let el;

  this.tooltip = document.createElement("div");
  this.tooltip.content = document.createElement("div");

  // Initializes close-button
  if (window.o_global.device.isTouchable || this.triggerClick) {
    if (this.hasCloseButton) {
      this._initCloseButton();
    }
  }

  // Set content
  if (this.reference) {
    if (this.referenceToClone) {
      el = document.getElementById(this.reference).cloneNode(true);
    } else {
      el = document.getElementById(this.reference);
    }

    el.removeAttribute("id"); // Important to remove style "display:none"
    el.removeAttribute("style"); // Check this!
    this.tooltip.content.appendChild(el);
  } else {
    this.tooltip.content.innerHTML = this.text ? this.text : ""; // FIXME: set TT isBroken if no content
  }

  this.tooltip.appendChild(this.tooltip.content);

  // Set classes
  this.addTooltipStyleClass(this.tooltip, this.baseClass);
  if (this.type) {
    this.addTooltipStyleClass(this.tooltip, `${this.baseClass}--${this.type}`);
  }
  this.addTooltipStyleClass(this.tooltip, this.orientationVariations[this.orientation]);

  if (this.additionalContainerClasses) {
    this.addTooltipStyleClass(this.tooltip, this.additionalContainerClasses);
  }

  this.addTooltipStyleClass(this.tooltip.content, "p_tooltip__content");

  if (this.additionalStyleClasses) {
    this.addTooltipStyleClass(this.tooltip.content, this.additionalStyleClasses);
  }

  if (this.position.match(/^(-?\d+);(-?\d+)$/)) {
    this.tooltipX = parseInt(RegExp.$1, 10);
    this.tooltipY = parseInt(RegExp.$2, 10);
  }

  if ((window.o_global.device.isTouchable && this.showForTouch) || this.triggerClick) {
    if ("onpointerdown" in window && !("ontouchstart" in window)) {
      this.tooltip.addEventListener("pointerdown", function (e) {
        e.stopPropagation();
      });
    } else {
      this.tooltip.addEventListener("touchstart", function (e) {
        e.stopPropagation();
      });
    }
  }
};

/**
 * Initializes a close-button (only for touch devices) with an eventListener on touchstart to close tooltip.
 *
 * @private
 */
window.o_global.pali.Tooltip.prototype._initCloseButton = function () {
  this.tooltip.close = document.createElement("a");
  this.tooltip.close.classList.add("p_tooltip__close");
  this.tooltip.close.addEventListener("click", window.o_util.core.bind(this, this.toggleTooltip));

  this.tooltip.appendChild(this.tooltip.close);
};

/**
 * Helper function to get a Pixel-String (e.g. to set css-style: top- and left-position).
 *
 * @param {Number} val  Value
 *
 * @return {String}     Returns convertet Pixel-String
 */
window.o_global.pali.Tooltip.prototype._getPixel = function (val) {
  return `${parseInt(val, 10)}px`;
};

/**
 * Creates and returns a new, throttled version of the passed function, that, when invoked repeatedly, will only
 * actually call the original function at most once per every wait milliseconds. Useful for rate-limiting events that
 * occur faster than you can keep up with or than you need it.
 *
 * @private
 *
 * @param {Function} fn         Function to call by timer.
 * @param {Number} [threshold]    Time to call fn, default 250ms.
 * @param {Object} [scope]        Scope
 *
 * @return {Function}           Function
 */
window.o_global.pali.Tooltip.prototype._throttle = function (fn, threshold, scope) {
  let last;
  let deferTimer;
  const timer = threshold || 250;

  return function () {
    const context = scope || this;
    const now = new Date();
    const args = arguments;

    if (last && now < last + timer) {
      // Hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, timer);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

/**
 * Scans document for tooltip-triggers and creates Tooltip-Instances.
 */
window.o_global.pali.tooltipHandler = (function () {
  let activeTooltip;
  const triggerClass = "js_hasPaliTooltip";
  const supportsOrientationChange = "onorientationchange" in window;
  const orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";

  window.o_global.eventLoader.onReady(80, function () {
    if (window.o_global.device.isTouchable) {
      if ("onpointerdown" in window && !("ontouchstart" in window)) {
        document.body.addEventListener("pointerdown", _buildTooltip);
      } else {
        document.body.addEventListener("touchstart", _buildTooltip);
      }

      window.addEventListener(orientationEvent, blurTooltip);

      // Registers a callback or excecutes it immediately, if hybrid is detected
      window.o_global.device.hybrid.executeOrRegisterCallback(updateHybrid);
    } else {
      document.body.addEventListener("click", _buildTooltip);
      document.body.addEventListener("mouseover", _buildTooltip);
    }
  });

  /**
   * Initializes Tooltip, if trigger has touchstart or mouseover registered.
   *
   * @private
   *
   * @param {Object} e    Event
   */
  function _buildTooltip(e) {
    const eventTarget = e.target || event.srcElement;
    let tooltip = null;
    let triggerElement;

    triggerElement = window.o_util.dom.getParentByClassName(eventTarget, triggerClass);

    if (!triggerElement) {
      return;
    }

    if (triggerElement.tooltipInstance) {
      if (
        (triggerElement.tooltipInstance.triggerClick && e.type === "click") ||
        (!triggerElement.tooltipInstance.triggerClick && e.type !== "click")
      ) {
        triggerElement.tooltipInstance.activateTooltip(e); // The tooltipInstance is typeof Tooltip
      }
    } else {
      tooltip = new window.o_global.pali.Tooltip(triggerElement); // New Instance of Tooltip Class (not equal to Tooltip.tooltip!)

      if (
        (tooltip.triggerClick && e.type === "click") ||
        (!tooltip.triggerClick && e.type !== "click")
      ) {
        tooltip.activateTooltip(e); // The tooltipInstance is typeof Tooltip
      }
    }

    if (!!triggerElement.tooltipInstance.getShowForTouch() && e.type === "click") {
      window.o_util.event.stop(e);
    }
  }

  /**
   * Only used for touch devices, because no all devices can handle a blur-event.
   *
   * @param {Object} e    Event
   */
  function blurTooltip(e) {
    if (!!activeTooltip && activeTooltip.tooltipIsVisible) {
      if (
        !("onpointerdown" in window) ||
        ("onpointerdown" in window && e.target !== activeTooltip.trigger)
      ) {
        activeTooltip.avoidCloseTooltip = false;
        activeTooltip.hideTooltip();
      }
    }
  }

  /**
   * Sets a new activeTooltip and closes the old tooltip (if still open).
   *
   * @param {Object} tooltip      {o_global.pali.Tooltip}
   */
  function changeActiveTooltip(tooltip) {
    if (!!activeTooltip && activeTooltip !== tooltip) {
      activeTooltip.avoidCloseTooltip = false;
      activeTooltip.hideTooltip();
    }

    activeTooltip = tooltip;
  }

  /**
   * Removes initialized tooltips from triggers.
   *
   * @param {Array} domArr    Array of DOM Elements
   */
  function removeTooltip(domArr) {
    for (let i = domArr.length - 1; i >= 0; i--) {
      if (domArr[i].tooltipInstance) {
        domArr[i].tooltipInstance.deactivateTooltip();
      } else if (domArr[i]) {
        domArr[i].classList.remove("js_hasPaliTooltip");
      }
    }
  }

  /**
   * Changes all classes from "js_hasPaliTooltip--done" to "js_hasPaliTooltip"
   */
  function resetTooltipClasses() {
    const initializedElements = document.getElementsByClassName("js_hasPaliTooltip--done");

    for (let i = initializedElements.length - 1; i >= 0; i--) {
      initializedElements[i].classList.add("js_hasPaliTooltip");
      initializedElements[i].classList.remove("js_hasPaliTooltip--done");
    }
  }

  /**
   * Initializes Mouseevents, if it is a hybrid device
   * If Hybrid-Device is detected after initialization, function is called by the window.o_global.helper.hybrid, if Callback-Function is registered
   *
   */
  function updateHybrid() {
    document.body.addEventListener("mouseover", _buildTooltip);
  }

  return {
    blurTooltip,
    changeActiveTooltip,
    removeTooltip,
    resetTooltipClasses,
    updateHybrid,
  };
})();
